import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import {
    getAllBusinessTypesUrl,
    getKycStatusUrl,
    getKycTypesUrl,
    getMerchantProfileUrl,
    getMerchantsCategoryUrl,
    updateMerchantDetailsUrl,
    uploadKycUrl,
    merchantsOnboardingUrl,
    addNewBusinessUrl,
    changeModeTypeUrl,
    getMerchantDetailsByEmailUrl,
    getModeTypeUrl,
    uploadMerchantLogoUrl,
    inviteEmployeeUrl,
    suspendUserUrl,
    revokeInviteUrl,
    getInvitationUrl,
    acceptInviteUrl,
    resendInviteUrl,
    updateUserRoleUrl,
    twoFaSetupUrl,
    twoFaEnableUrl,
    twoFaStatusUrl,
    twoFaDisableUrl
} from '../../../../shared/helpers/endPoints';

import { MerchantActionType } from '../actions/action';

import { fetchJSON } from '../../../../shared/helpers/apiCalls';

import {
    getKycStatus,
    getMerchantProfile,
    getOnboardingProfile,
    setAddNewBusinessError,
    setAllbusinessTypes,
    setKycStatus,
    setKycTypes,
    setMerchantCategory,
    setMerchantDetails,
    setMerchantProfile,
    setOnboardingProfile,
    togglingAppModeSuccess,
    getModeTypeSuccess,
    getModeTypeFailure,
    getModeType,
    getMerchantDetails,
    getKycTypes,
    inviteEmployeeSuccess,
    inviteEmployeeFailure,
    getInvitationSuccess,
    getInvitationFailure,
    acceptInviteSuccess,
    acceptInviteFailure,
    resendInviteSuccess,
    resendInviteFailure,
    suspendUserSuccess,
    suspendUserFailure,
    revokeInviteSuccess,
    revokeInviteFailure,
    updateUserRoleSuccess,
    updateUserRoleFailure,
    twoFaSetupSuccess,
    twoFaSetupFailure,
    twoFaEnableSuccess,
    twoFaEnableFailure,
    twoFaStatus,
    twoFaStatusSuccess,
    twoFaStatusFailure,
    twoFaDisableSuccess,
    twoFaDisableFailure
} from '../actions/action.creators';

import { setRandomAction } from '../../../../store/action';
import { authProcess } from '../../../../store/auth/register/action';
import { setError, setModal, setProcessLoading, setSuccess } from '../../../../store/utils/action';
import { getStoreLocal, setStoreLocal } from '../../../../shared/helpers/utils';
import { authService } from '../../../users/services/dependency.injection';

const {
    GET_ALL_BUSINESS_TYPES,
    GET_KYC_STATUS,
    GET_KYC_TYPES,
    GET_MERCHANTS_CATEGORY,
    GET_MERCHANT_DETAILS,
    GET_MERCHANT_PROFILE,
    UPDATE_MERCHANT_DETAILS,
    UPLOAD_KYC,
    UPLOAD_MERCHANTS_ONBOARDING,
    GET_ONBOARDING_PROFILE,
    SET_ADD_NEW_BUSINESS,
    TOGGLING_APP_MODE,
    GET_MODE_TYPE,
    UPLOAD_MERCHANT_LOGO,
    SUSPEND_USER,
    REVOKE_INVITE,
    GET_INVITATION,
    INVITE_EMPLOYEE,
    ACCEPT_INVITE,
    RESEND_INVITE,
    UPDATE_USER_ROLE,
    TWO_FA_SETUP,
    TWO_FA_ENABLE,
    TWO_FA_STATUS,
    TWO_FA_DISABLE
} = MerchantActionType;

export const getMerchantState = state => state.Merchants;

function* callGetModeType() {
    const userInfo = authService.userInfo();
    const user_name = userInfo?.user_name;
    const access_token = authService.accessToken();

    try {
        const mode = {
            method: 'GET',
            url: getModeTypeUrl(),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: { 'user-email': !!user_name ? user_name : '' }
        };

        const response = yield call(fetchJSON, mode);

        // Get ModeType and persist it into the local storage
        const appMode = response.data['modeType'];

        setStoreLocal('modeType', appMode);

        yield put(togglingAppModeSuccess(appMode === 'LIVE' ? 'Live Mode' : 'Test Mode'));

        yield put(getMerchantDetails());

        yield put(getModeTypeSuccess());
    } catch (err) {
        setStoreLocal('modeType', 'TEST');
        yield put(togglingAppModeSuccess('Test Mode'));
        yield put(getModeTypeFailure(err));
        yield put(getMerchantDetails());
    }
}

function* callChangeModeType({ payload: { merchantId, mode } }) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    const userInfo = authService.userInfo();
    const user_name = userInfo?.user_name;

    try {
        const options = {
            method: 'POST',
            url: changeModeTypeUrl(),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ type: mode, email: user_name })
        };

        yield call(fetchJSON, options);

        yield put(getModeType());
    } catch (error) {
        yield put(getModeType());
    }
}

function* callGetOnboardingProfile({ payload: merchant_id }) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: merchantsOnboardingUrl(modeType, merchant_id),
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(setOnboardingProfile(response.data));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
    }
}

function* callUploadMerchantsOnboarding({
    payload: {
        values: { merchantDetails, merchant_id },
        history
    }
}) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    // let { modeType } = yield select(getMerchantState);
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: merchantsOnboardingUrl(modeType, merchant_id),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify(merchantDetails)
        };

        yield call(fetchJSON, options);

        history.replace('/dashboard');
        yield put(setProcessLoading(false));
        yield put(setSuccess('You have successfully updated part of your details!!!'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setError(message));
        yield put(setSuccess(''));
        yield put(setProcessLoading(false));
    }
}

function* callUploadKyc({ payload: value }) {
    // const { user_id } = userInfo();
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        var formData = new FormData();

        formData.append('document', value.rawFile);
        formData.append('documentId', value.documentID);

        const options = {
            method: 'POST',
            url: uploadKycUrl(modeType, value.merchantId, value.kycTypeId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'multipart/form-data'
            },
            data: formData
        };

        yield call(fetchJSON, options);
        // set loading to false
        yield put(setProcessLoading(false));
        // close the profile verification modal after submitting successfully
        yield put(setModal({ profileModal: false }));
        // set error message to be displayed
        yield put(
            setSuccess('Your kyc document has been successfully updated, we will keep you posted for further actions')
        );
        // call kyc status to update user kyc status
        yield put(getKycStatus(value.merchantId));
        yield put(getKycTypes(value.merchantId));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
        yield put(setProcessLoading(false));

        yield put(setRandomAction({ errorProfileVerification: message }));
    }
}

function* callGetKycTypes({ payload: merchantId }) {
    const access_token = authService.accessToken();
    // const { modeType } = yield select(getMerchantState);
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getKycTypesUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setKycTypes(response.data));
        // localStorage.setItem('kycStatus', response.data.kycStatus)
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callGetMerchantKycStatus({ payload: merchantId }) {
    const access_token = authService.accessToken();
    // const { modeType } = yield select(getMerchantState);
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getKycStatusUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setKycStatus(response.data));
        // localStorage.setItem('kycStatus', response.data.kycStatus)
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callMerchantProfie({ payload: merchantId }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getMerchantProfileUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setMerchantProfile(response.data));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callMerchantDetails() {
    // todo: com back for this
    // this is the process that follws the login process and it will be called immediately
    // token after the user has logged in
    const userInfo = authService.userInfo();
    const user_name = userInfo?.user_name;
    const access_token = authService.accessToken();

    try {
        const modeType = getStoreLocal('modeType');

        // Get Merchants Details ->
        const options = {
            method: 'GET',
            url: getMerchantDetailsByEmailUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'X-AUTH-PASSWORD': 'password'
            },
            params: { userEmail: user_name }
        };

        const response = yield call(fetchJSON, options);

        const merchantID = response.data[0].id;

        authService.setToken('merchant-id', merchantID);

        yield put(setMerchantDetails(response.data));
        yield put(authProcess(false));

        const token = authService.getToken('merchant-id');
        const merchantId = token ? token : response.data[0].id;

        yield put(getMerchantProfile(merchantId));
        yield put(getKycStatus(merchantId));
        yield put(getKycTypes(merchantId));
        yield put(getOnboardingProfile(merchantId));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
        toast.error(message);
        // setPageLoading(false)
        /* If token not present or expired,
           log user out */
        // setSession(null);
        authService.setToken('auth-spay-user', null);
        yield put(authProcess(false));
    }
}

function* callUpdateMerchant({ payload: value }) {
    // token after the user has logged in
    const access_token = authService.accessToken();
    // const { modeType } = yield select(getMerchantState);
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: updateMerchantDetailsUrl(modeType, value.merchant_id),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            },
            data: JSON.stringify(value)
        };

        yield call(fetchJSON, options);

        yield put(setProcessLoading(false));
        yield put(setSuccess('You have successfully updated part of your details!!!'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
        toast.error(message);
        yield put(setError(message));
        yield put(authProcess(false));
        yield put(setProcessLoading(false));
    }
}

function* callGetMerchantsCategory() {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getMerchantsCategoryUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);
        yield put(setMerchantCategory(response.data.content));
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callGetAllBusinessTypes() {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: getAllBusinessTypesUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(setAllbusinessTypes(response.data.content));
        // localStorage.setItem('seeking', response.data.access_token);
    } catch (error) {
        // let message = error === undefined ? 'Something went wrong please try again later' : error.data.message;
    }
}

function* callAddNewBusiness({ payload: value }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: addNewBusinessUrl(modeType),
            data: JSON.stringify(value),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        yield call(fetchJSON, options);
        yield put(setProcessLoading(false));
        yield put(setSuccess('You have successfully added a business'));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data.error.message;
        yield put(setProcessLoading(false));
        yield put(setAddNewBusinessError(message));
    }
}

function* callUploadMerchantLogo({ payload: { logoFile, merchantId } }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType') || 'TEST';

    try {
        yield put(setProcessLoading(true));

        const formData = new FormData();
        formData.append('file', logoFile);

        const options = {
            method: 'POST',
            url: uploadMerchantLogoUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'multipart/form-data'
            },
            data: formData
        };

        yield call(fetchJSON, options);

        yield put(getMerchantProfile(merchantId));

        yield put(setSuccess('Merchant logo uploaded successfully!'));
        yield put(setProcessLoading(false));
    } catch (error) {
        const message = error?.data?.message || 'Failed to upload merchant logo';
        toast.error(message);
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* callInviteEmployee({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { merchantId, email, role } = payload;

        const options = {
            method: 'POST',
            url: inviteEmployeeUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ email, role, environment: modeType })
        };

        const response = yield call(fetchJSON, options);

        yield put(inviteEmployeeSuccess(response));

        yield put(setSuccess('Invitation sent successfully'));
        yield put(setProcessLoading(false));
    } catch (error) {
        let message =
            error === undefined
                ? 'Something went wrong please try again later'
                : error.data?.error?.message || error.data?.message;

        yield put(inviteEmployeeFailure(message));
        yield put(setError(message));
        yield put(setProcessLoading(false));
    }
}

function* callGetInvitation({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const merchantId = authService.getToken('merchant-id');

        const options = {
            method: 'GET',
            url: getInvitationUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json',
                'X-AUTH-PASSWORD': 'password'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(getInvitationSuccess(response.data.content));
    } catch (error) {
        let message = error === undefined ? 'Something went wrong please try again later' : error.data?.message;

        yield put(getInvitationFailure(message));
    }
}

function* callAcceptInvite({ payload }) {
    try {
        const { token, firstName, lastName, password, environment } = payload;

        yield put(setProcessLoading(true));

        const modeType = environment || getStoreLocal('modeType') || 'TEST';

        const options = {
            method: 'POST',
            url: acceptInviteUrl(modeType),
            headers: {
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({
                token,
                firstName,
                lastName,
                password
            })
        };

        const response = yield call(fetchJSON, options);

        yield put(acceptInviteSuccess(response));
        yield put(setSuccess('Account created successfully!'));
    } catch (error) {
        let message =
            error === undefined
                ? 'Something went wrong please try again later'
                : error.data?.error?.message || error.data?.message;

        yield put(acceptInviteFailure(message));
        yield put(setError(message));
    } finally {
        yield put(setProcessLoading(false));
    }
}

function* callResendInvite({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { email } = payload;

        const options = {
            method: 'POST',
            url: resendInviteUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: { email, environment: modeType }
        };

        const response = yield call(fetchJSON, options);

        yield put(resendInviteSuccess(response));
        yield put(setSuccess('Invitation resent successfully'));
    } catch (error) {
        let message =
            error === undefined
                ? 'Something went wrong please try again later'
                : error.data?.error?.message || error.data?.message;

        yield put(resendInviteFailure(message));
        yield put(setError(message));
    }
}

function* callSuspendUser({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { merchantId, userId, isSuspended } = payload;

        const options = {
            method: 'PATCH',
            url: suspendUserUrl(modeType, merchantId, userId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ isSuspended })
        };

        yield call(fetchJSON, options);

        yield put(suspendUserSuccess());
        yield put(setSuccess(`User ${isSuspended ? 'suspended' : 'unsuspended'} successfully`));
    } catch (error) {
        const message = error?.data?.message || 'Something went wrong please try again later';
        toast.error(message);
        yield put(suspendUserFailure(message));
        yield put(setError(message));
    }
}

function* callRevokeInvite({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { merchantId, email } = payload;

        const options = {
            method: 'DELETE',
            url: revokeInviteUrl(modeType, merchantId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            params: { email }
        };

        yield call(fetchJSON, options);

        yield put(revokeInviteSuccess());
        yield put(setSuccess('Invite revoked successfully'));
    } catch (error) {
        const message = error?.data?.message || 'Something went wrong please try again later';
        toast.error(message);
        yield put(revokeInviteFailure(message));
        yield put(setError(message));
    }
}

function* callUpdateUserRole({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { merchantId, userId, role } = payload;

        const options = {
            method: 'PATCH',
            url: updateUserRoleUrl(modeType, merchantId, userId),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            },
            data: JSON.stringify({ role })
        };

        yield call(fetchJSON, options);

        yield put(updateUserRoleSuccess());
        yield put(setSuccess(`User role updated to ${role} successfully`));
    } catch (error) {
        const message = error?.data?.message || 'Something went wrong please try again later';
        toast.error(message);
        yield put(updateUserRoleFailure(message));
        yield put(setError(message));
    }
}

function* callTwoFaSetup() {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: twoFaSetupUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(twoFaSetupSuccess(response.data || response));
        yield put(setSuccess('2FA setup generated successfully'));
    } catch (error) {
        const message = error?.data?.message || 'Failed to setup 2FA';

        yield put(twoFaSetupFailure(message));
        yield put(setError(message));
    }
}

function* callTwoFaEnable({ payload }) {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const { code } = payload;

        const options = {
            method: 'POST',
            url: twoFaEnableUrl(modeType, code),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(twoFaEnableSuccess(response.data || response));
        yield put(setSuccess('2FA successfully enabled!'));
        yield put(twoFaStatus());
    } catch (error) {
        const message = error?.data?.message || 'Failed to enable 2FA';

        yield put(twoFaEnableFailure(message));
        yield put(setError(message));
    }
}

function* callTwoFaStatus() {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'GET',
            url: twoFaStatusUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(twoFaStatusSuccess(response.data || response));
    } catch (error) {
        const message = error?.data?.message || 'Failed to get 2FA status';

        yield put(twoFaStatusFailure(message));
    }
}

function* callTwoFaDisable() {
    const access_token = authService.accessToken();
    const modeType = getStoreLocal('modeType');

    try {
        const options = {
            method: 'POST',
            url: twoFaDisableUrl(modeType),
            headers: {
                Authorization: `Bearer ${access_token}`,
                'Content-Type': 'application/json'
            }
        };

        const response = yield call(fetchJSON, options);

        yield put(twoFaDisableSuccess(response.data || response));
        yield put(setSuccess('2FA successfully disabled!'));
        yield put(twoFaStatus());
    } catch (error) {
        const message = error?.data?.message || 'Failed to disable 2FA';

        yield put(twoFaDisableFailure(message));
        yield put(setError(message));
    }
}
export function* watchCallGetModeType() {
    yield takeEvery(GET_MODE_TYPE, callGetModeType);
}

export function* watchCallChangeModeType() {
    yield takeEvery(TOGGLING_APP_MODE, callChangeModeType);
}

export function* watchCallAddNewBusiness() {
    yield takeEvery(SET_ADD_NEW_BUSINESS, callAddNewBusiness);
}

export function* watchCallGetOnboardingProfile() {
    yield takeEvery(GET_ONBOARDING_PROFILE, callGetOnboardingProfile);
}

export function* watchCallGetKycTypes() {
    yield takeEvery(GET_KYC_TYPES, callGetKycTypes);
}
export function* watchCallUploadKyc() {
    yield takeEvery(UPLOAD_KYC, callUploadKyc);
}
export function* watchCallKycDetails() {
    yield takeEvery(GET_KYC_STATUS, callGetMerchantKycStatus);
}
export function* watchMerchantProfile() {
    yield takeEvery(GET_MERCHANT_PROFILE, callMerchantProfie);
}
export function* watchMerchantDetails() {
    yield takeEvery(GET_MERCHANT_DETAILS, callMerchantDetails);
}
export function* watchUploadMerchantsOnboarding() {
    yield takeEvery(UPLOAD_MERCHANTS_ONBOARDING, callUploadMerchantsOnboarding);
}
export function* watchUpdateMerchantDetails() {
    yield takeEvery(UPDATE_MERCHANT_DETAILS, callUpdateMerchant);
}

export function* watchGetMerchantsCategory() {
    yield takeEvery(GET_MERCHANTS_CATEGORY, callGetMerchantsCategory);
}
export function* watchGetAllBusinessTypes() {
    yield takeEvery(GET_ALL_BUSINESS_TYPES, callGetAllBusinessTypes);
}
export function* watchUploadMerchantLogo() {
    yield takeEvery(UPLOAD_MERCHANT_LOGO, callUploadMerchantLogo);
}

export function* watchInviteEmployee() {
    yield takeEvery(INVITE_EMPLOYEE, callInviteEmployee);
}
export function* watchSuspendUser() {
    yield takeEvery(SUSPEND_USER, callSuspendUser);
}

export function* watchRevokeInvite() {
    yield takeEvery(REVOKE_INVITE, callRevokeInvite);
}

export function* watchGetInvitation() {
    yield takeEvery(GET_INVITATION, callGetInvitation);
}

export function* watchAcceptInvite() {
    yield takeEvery(ACCEPT_INVITE, callAcceptInvite);
}

export function* watchResendInvite() {
    yield takeEvery(RESEND_INVITE, callResendInvite);
}

export function* watchUpdateUserRole() {
    yield takeEvery(UPDATE_USER_ROLE, callUpdateUserRole);
}

export function* watchTwoFaSetup() {
    yield takeEvery(TWO_FA_SETUP, callTwoFaSetup);
}

export function* watchTwoFaEnable() {
    yield takeEvery(TWO_FA_ENABLE, callTwoFaEnable);
}

export function* watchTwoFaStatus() {
    yield takeEvery(TWO_FA_STATUS, callTwoFaStatus);
}

export function* watchTwoFaDisable() {
    yield takeEvery(TWO_FA_DISABLE, callTwoFaDisable);
}
function* MerchantSaga() {
    yield all([
        fork(watchGetAllBusinessTypes),
        fork(watchGetMerchantsCategory),
        fork(watchUpdateMerchantDetails),
        fork(watchMerchantDetails),
        fork(watchMerchantProfile),
        fork(watchCallKycDetails),
        fork(watchUploadMerchantsOnboarding),
        fork(watchCallUploadKyc),
        fork(watchCallGetKycTypes),
        fork(watchCallGetOnboardingProfile),
        fork(watchCallAddNewBusiness),
        fork(watchCallChangeModeType),
        fork(watchCallGetModeType),
        fork(watchUploadMerchantLogo),
        fork(watchInviteEmployee),
        fork(watchSuspendUser),
        fork(watchRevokeInvite),
        fork(watchGetInvitation),
        fork(watchAcceptInvite),
        fork(watchResendInvite),
        fork(watchUpdateUserRole),
        fork(watchTwoFaSetup),
        fork(watchTwoFaEnable),
        fork(watchTwoFaStatus),
        fork(watchTwoFaDisable)
    ]);
}

export default MerchantSaga;
